import React from 'react';
import { Card } from 'react-bootstrap';

const ServiceCard = ({ title, description, imageUrl, icon }) => {
  return (
    <Card className="card-modern h-100 border-0">
      <div 
        style={{ 
          height: '200px', 
          background: `url(${imageUrl}) center/cover no-repeat`,
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px'
        }}
      />
      <Card.Body className="p-4">
        <div className="d-flex align-items-center mb-3">
          <div style={{
            width: '48px',
            height: '48px',
            backgroundColor: 'var(--soft-sage)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '1rem'
          }}>
            <span style={{ color: 'var(--muted-gold)', fontSize: '1.5rem' }}>
              {icon}
            </span>
          </div>
          <h3 className="h4 mb-0">{title}</h3>
        </div>
        <Card.Text style={{ color: '#666' }}>
          {description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default ServiceCard;